<form autocomplete="off" [formGroup]="form" (ngSubmit)="validateForm()">
    <h4>Detalle del eje</h4>
    <hr>
    <div class="col-12">
        <div class="form-group row">
            <div class="textOnInput col-12">
                <label class="form-label" for="inputText">Nombre</label>
                <input class="form-control form-input" type="text" placeholder="Nombre" formControlName="label"
                    autocomplete="off" [class.is-invalid]="campoNoValido('label')">
                <small class="text-danger" *ngIf="campoNoValido('label')">Este campo es requerido</small>
            </div>
            <div class="textOnInput col-12">
                <label class="form-label" for="inputText">Detalle</label>
                <input class="form-control form-input" type="text" placeholder="Detalle del eje"
                    formControlName="detail">
            </div>
            <div class="textOnInput col-6">
                <label class="form-label" for="inputText">Tipo de eje</label>
                <select class="form-control form-input" name="" formControlName="type">
                    <option class="form-control" [ngValue]="null">Seleccione un tipo</option>
                    <option *ngFor="let t of axisTypes" value="{{t.id}}">
                        {{t.name}}
                    </option>
                </select>
            </div>
            <div class="col-6" style="margin-top: 1rem;">
                <div class="custom-control custom-switch">
                    <input class="custom-control-input" type="checkbox" id="switch1" formControlName="isActive">
                    <label class="custom-control-label" for="switch1">Estado</label>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6">
            <div class="row">
                <div class="col-6 input-group">
                    <button type="button" class="btn btn-outline-secondary btn-block" (click)="cancel()">
                        Cancelar
                    </button>
                </div>
                <div class="col-6 input-group">
                    <button type="submit" class="btn btn-outline-primary btn-block">
                        Guardar
                    </button>
                </div>
            </div>
        </div>
        <div class="col-md-3"></div>
    </div>
    <ng-container *ngIf="!hiddenMsg">
        <app-alert [message]="msg.message" [status]="msg.status"></app-alert>
    </ng-container>
</form>